/**
 * Shared styles and types for chart style section components.
 */
import { makeStyles, tokens } from "@fluentui/react-components";
import type { TypeStyle } from "../visualConfig";

export interface ChartStyleSectionProps {
  chartStyle: TypeStyle;
  onStyleChange: (patch: Partial<TypeStyle>) => void;
}

export const useSliderStyles = makeStyles({
  sliderField: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  sliderRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  sliderValue: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3,
    minWidth: "32px",
    textAlign: "right",
  },
});